<template>
  <div :class="'similar-card resultdata-area ' + (props.result ? 'simpro-area' : '')">
    <div class="flex item-name-area">
      <div class="product-name flex items-center">
        <p>{{ props.result.atto_id }}</p>
      </div>
    </div>
    <div class="img-container emphable-img">
      <AtomImage :exatoms="props.result.structure" />
    </div>
    <div class="supplier-bottoms-area flex items-end justify-between mt-1">
      <!-- 類似品用詳細表示ボタン -->
      <q-btn color="primary" @click="simResuldDataDetail(props.result.atto_id)">詳細</q-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import AtomImage from '../images/AtomImage.vue';

// 検索結果interface
interface Result {
  atto_id: string;
  atto_supplier_count: number;
  order_count: number;
  condition_id: number;
  result_id: number;
  result_number: number;
  structure: string;
}

interface Props {
  // 検索結果
  result: Result;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  (event: 'onSimilerDetail', selectAttoId: string): void;
}>();

const simResuldDataDetail = (selectAttoId: string) => {
  emit('onSimilerDetail', selectAttoId);
};
</script>

<style scoped>
p,
label,
span,
ul,
li {
  margin: 0;
  padding: 0;
}

li {
  list-style: none;
}

.resultdata-area {
  width: 100%;
}

.resultdata-area .img-container {
  height: 160px;
  display: flex;
  justify-content: center;
}

.resultdata-area .product-name {
  font-weight: bold;
}

.resultdata-area .product-name p {
  letter-spacing: 1px;
  color: var(--q-plainBlack);
}

.resultdata-area .img-container.emphable-img {
  position: relative;
}

.resultdata-area .img-container .q-img {
  width: 80%;
}

.resultdata-area .q-btn {
  width: 70px;
  padding: 10px 0;
  font-size: 1.1rem;
  line-height: 1.1rem;
  padding-left: 2px;
  letter-spacing: 2px;
}

.resultdata-area .supplier-bottoms-area {
  margin-top: 24px;
  padding-left: 10px;
  padding-right: 4px;
}

.resultdata-area .supplier-num-area {
  width: calc(100% - 78px);
  position: relative;
}

.resultdata-area .supplier-num-area .tag-area {
  position: absolute;
  right: -0;
  top: -30px;
  display: flex;
  justify-content: flex-end;
}

.resultdata-area .supplier-num-area .tag-area p {
  width: 116px;
  border-radius: 4px;
  background-color: rgb(187, 219, 175, 0.7);
  padding: 2px 4px;
  text-align: center;
}

/* 類似品の場合 */
.resultdata-area.simpro-area .flex.item-name-area {
  padding: 10px 10px 0;
}

.resultdata-area.simpro-area .img-container {
  height: auto;
}

.resultdata-area.simpro-area .supplier-bottoms-area {
  margin-top: 10px;
  padding: 0 10px;
}

.resultdata-area.simpro-area .supplier-num-area {
  width: calc(100% - 100px);
}

.resultdata-area.simpro-area .supplier-num-area .tag-area {
  position: static;
}

.resultdata-area.simpro-area .product-name p {
  font-weight: bold;
}

.similar-card .product-name p {
  letter-spacing: 1px;
  color: var(--q-plainBlack);
  font-weight: 700;
  line-height: 1.1rem;
  font-size: 1.1rem;
  padding-top: 2px;
}

.similar-card .q-btn {
  width: 90px;
  font-size: 1.1rem;
  line-height: 1.1rem;
  letter-spacing: 2px;
  min-height: 40px;
  padding: 5px 0px 5px 2px;
}

.similar-card .supplier-number {
  font-size: 1.2rem;
  line-height: 1.2rem;
  font-weight: 600;
  letter-spacing: 2px;
  padding-left: 4px;
  color: var(--q-primary);
}

@media screen and (min-width: 1440px) {
  .resultdata-area .img-container {
    height: 180px;
  }
}

@media screen and (min-width: 1680px) {
  .resultdata-area .img-container {
    height: 200px;
  }

  .resultdata-area .supplier-bottoms-area {
    padding-left: 10px;
    padding-right: 10px;
  }

  .supplier-num-area {
    width: calc(100% - 120px);
  }
}
</style>
